// Navigation.js
import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import favicon from '../../assets/logo.png'
import {
  NavigationContainer,
  TabStyles
} from './Navigation.style'

const Navigation = () => {
  const navRef = useRef(null)

  useEffect(() => {
    const navNode = navRef.current
    if (!navNode) return

    // reveal animation on mount
    setTimeout(() => navNode.classList.add('visible'), 60)

    // add scrolled class when user scrolls down
    const onScroll = () => {
      if (window.scrollY > 10) navNode.classList.add('scrolled')
      else navNode.classList.remove('scrolled')

      // update active link
      const anchors = Array.from(navNode.querySelectorAll('a[href^="#"]'))
      let current = null
      anchors.forEach(a => {
        const id = a.getAttribute('href').slice(1)
        const section = document.getElementById(id)
        if (section) {
          const rect = section.getBoundingClientRect()
          if (rect.top <= 120 && rect.bottom > 120) {
            current = a
          }
        }
      })
      anchors.forEach(a => a.classList.toggle('active', a === current))
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    // initial call
    onScroll()

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  useEffect(() => {
    // indicator/tab logic
    const container = navRef.current
    if (!container) return

    const menuItems = container.querySelectorAll('.tab-button')
    const indicator = container.querySelector('.indicator')
    if (!menuItems.length || !indicator) return

    let activeItemIndex = 0

    function updateIndicator(index) {
      const activeItem = menuItems[index]
      const containerRect = container.querySelector('.tab-container').getBoundingClientRect()
      const activeItemRect = activeItem.getBoundingClientRect()

      // set indicator width slightly bigger than the active item
      const newWidth = Math.round(activeItemRect.width + 12)
      indicator.style.width = `${newWidth}px`

      const indicatorLeft = Math.floor(
        activeItemRect.left - containerRect.left -
        (newWidth - activeItemRect.width) / 2
      )

      indicator.style.transform = `translateX(${indicatorLeft}px)`
    }

    menuItems.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        const targetId = item.getAttribute('data-target')
        const targetEl = document.getElementById(targetId)
        if (targetEl) targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' })

        if (activeItemIndex !== index) {
          menuItems[activeItemIndex].classList.remove('active')
          item.classList.add('active')
          activeItemIndex = index
          updateIndicator(index)
        }
      })
    })

    // initialize
    setTimeout(() => updateIndicator(activeItemIndex), 80)
    window.addEventListener('resize', () => updateIndicator(activeItemIndex))

    return () => {
      window.removeEventListener('resize', () => updateIndicator(activeItemIndex))
    }
  }, [])

  return (
    <NavigationContainer ref={navRef}>
      <a href="#home" style={{ textDecoration: 'none', color: '#2C1F14' }}>
        <img src={favicon} alt="Logo" style={{ height: '40px', width: '40px', display: 'block' }} />
      </a>

      {/* Tab-style nav with indicator */}
      <TabStyles>
        <div className="tab-container">
          <div className="indicator" />
          <button className="tab-button active" data-text="Home" data-target="home" aria-label="Home"><span className="label">Home</span></button>
          <button className="tab-button" data-text="About" data-target="about" aria-label="About"><span className="label">About</span></button>
          <button className="tab-button" data-text="Projects" data-target="projects" aria-label="Projects"><span className="label">Projects</span></button>
        </div>
      </TabStyles>
      <Link to="/resume" style={{ textDecoration: 'none', color: '#B5624A', fontWeight: 700, fontSize: '0.95rem', padding: '0.4rem 1rem', border: '1px solid rgba(181,98,74,0.4)', borderRadius: '1rem', whiteSpace: 'nowrap' }}>Resume</Link>
    </NavigationContainer>
  )
}

export default Navigation
